import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  TextField,
} from '@mui/material';

const ABCDataSection = ({
  dataPoint,
  index,
  handleCheckboxChange,
  handleAbcChange,
  allGoalData,
}) => {
  const shouldShowABCData = 
    allGoalData?.DataEntrySelection?.DataEntrySelection?.includes('Add ABC Data') ||
    dataPoint?.selectedOptions?.includes('Add ABC Data');

  if (!shouldShowABCData) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={dataPoint?.selectedOptions?.includes('Add ABC Data')}
            onChange={(e) => handleCheckboxChange(index, e)}
            value='Add ABC Data'
          />
        }
        label='Add ABC Data'
      />
      {dataPoint?.selectedOptions?.includes('Add ABC Data') && (
        <Box sx={{ ml: 3, pl: 2, borderLeft: '2px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant='body1'
              sx={{ width: '20%', textAlign: 'right' }}
            >
              Antecedent:
            </Typography>
            <TextField
              fullWidth
              name='antecedent'
              margin='dense'
              value={dataPoint.abcData.antecedent}
              sx={{ width: '70%', padding: '0' }}
              className='input-height'
              onChange={(e) => handleAbcChange(index, e)}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant='body1'
              sx={{ width: '20%', textAlign: 'right' }}
            >
              Behavior:
            </Typography>
            <TextField
              fullWidth
              name='behavior'
              margin='dense'
              value={dataPoint.abcData.behavior}
              className='input-height'
              sx={{ width: '70%', padding: '0' }}
              onChange={(e) => handleAbcChange(index, e)}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant='body1'
              sx={{ width: '20%', textAlign: 'right' }}
            >
              Consequence:
            </Typography>
            <TextField
              fullWidth
              name='consequence'
              margin='dense'
              value={dataPoint.abcData.consequence}
              className='input-height'
              sx={{ width: '70%', padding: '0' }}
              onChange={(e) => handleAbcChange(index, e)}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant='body1'
              sx={{ width: '20%', textAlign: 'right' }}
            >
              Setting:
            </Typography>
            <TextField
              fullWidth
              name='setting'
              margin='dense'
              value={dataPoint.abcData.setting}
              className='input-height'
              sx={{ width: '70%', padding: '0' }}
              onChange={(e) => handleAbcChange(index, e)}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default ABCDataSection;
